import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-4" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-4 gap-x-4" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  class: "col"
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "flex items-center mt-5" }
const _hoisted_9 = { class: "mb-4 mt-2 text-slate-600" }

import AdminPageLayout from "@/layouts/default/admin/AdminPageLayout.vue";
import { ref, onMounted, computed, reactive } from "vue";
import { getTodayDate, getFirstDayOfMonth } from "@/_helpers/dateManipulations";
import {
  generateFileName,
  downloadFile,
  generateFileUrl,
} from "@/_helpers/fileManipulations";
import { useToast } from "primevue/usetoast";
import { searchSupplierOptions } from "@/_services/supplier/supplier";
import { exportTypes } from "@/constants/export/exports";
import { exportTypesSql } from "@/constants/export/exportsSql";
import CodeViewer from "@/components/utility/CodeViewer";

const exportFileExtension = ".csv";

export default /*#__PURE__*/_defineComponent({
  __name: 'SoldExport',
  setup(__props) {

const startDate = ref<string>("");
const endDate = ref<string>("");
const selectedExportType = ref<string>("sold_documents");
const isLoading = ref<boolean>(true);
const supplier = ref<string>("");
const toast = useToast();
const formValues = reactive({});

const exportTypesOptions = computed(() => {
  return Object.keys(exportTypes).map((key) => ({
    value: key,
    label: exportTypes[key].label,
  }));
});

const exportType = computed(() => {
  return exportTypes[selectedExportType.value];
});

const exportTypeSql = computed(() => {
  return exportTypesSql[selectedExportType.value];
});

// This is necessary to fix a bug on code viewer details display
const filters = computed(() => {
  return formValues;
})

onMounted(() => {
  startDate.value = getFirstDayOfMonth();
  endDate.value = getTodayDate();
  isLoading.value = false;
});

const downloadCsvFile = async () => {
  isLoading.value = true;

  try {
    toast.add({
      severity: "warn",
      summary: "Attention",
      detail: "Veuillez ne pas quitter la page pendant l'export",
      life: 4000,
    });

    const csvData: string = await exportType.value["callback"](
      ...Object.values(formValues)
    );
    const fileName = generateFileName(
      exportType.value["fileNamePrefix"],
      exportFileExtension
    );
    const url = generateFileUrl(csvData);
    downloadFile(fileName, url);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.add({
      severity: "error",
      summary: "Erreur",
      detail: "Erreur lors du téléchargement",
      life: 4000,
    });
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(AdminPageLayout, null, {
    titleName: _withCtx(() => [
      _createTextVNode(" Exports des ventes ")
    ]),
    titleAction: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FormKit, {
          type: "select",
          name: "exportType",
          modelValue: selectedExportType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedExportType).value = $event)),
          validation: "required",
          options: exportTypesOptions.value,
          "validation-messages": {
            required: 'Veuillez choisir un type d\'export.',
          }
        }, null, 8, ["modelValue", "options", "validation-messages"])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_FormKit, {
        type: "form",
        id: "exportForm",
        actions: false,
        onSubmit: downloadCsvFile,
        modelValue: formValues,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValues) = $event))
      }, {
        default: _withCtx(({ state: { valid } }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormKit, {
                  type: "datepicker",
                  name: "startDate",
                  label: "Date de début*",
                  validation: "required|checkDatesIntervalRules",
                  "validation-messages": {
                  required: 'Date obligatoire.',
                  checkDatesIntervalRules:
                    'La date de début doit être inférieur ou égale à la date de fin.',
                },
                  "validation-visibility": "live",
                  format: "DD/MM/YYYY",
                  "value-format": "YYYY-MM-DD",
                  modelValue: startDate.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event))
                }, null, 8, ["validation-messages", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FormKit, {
                  type: "datepicker",
                  name: "endDate",
                  label: "Date de fin*",
                  validation: "required|checkDatesIntervalRules",
                  "validation-messages": {
                  required: 'Date obligatoire.',
                  checkDatesIntervalRules:
                    'La date de fin doit être supérieure ou égale à la date de début.',
                },
                  "validation-visibility": "live",
                  format: "DD/MM/YYYY",
                  "value-format": "YYYY-MM-DD",
                  modelValue: endDate.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event))
                }, null, 8, ["validation-messages", "modelValue"])
              ]),
              (exportType.value.hasSupplierFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_FormKit, {
                      type: "autocomplete",
                      label: "Fournisseur",
                      name: "supplier",
                      placeholder: "Sélectionner un fournisseur",
                      options: _unref(searchSupplierOptions),
                      modelValue: supplier.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((supplier).value = $event))
                    }, null, 8, ["options", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_FormKit, {
                    type: "submit",
                    label: "Exporter",
                    class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true }),
                    disabled: !valid || isLoading.value
                  }, null, 8, ["disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(exportType.value.description), 1),
              _createVNode(_unref(CodeViewer), {
                code: exportTypeSql.value,
                details: filters.value
              }, null, 8, ["code", "details"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})